import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { clsx } from 'clsx'
import { Bars3Icon, ChatBubbleLeftIcon } from '@heroicons/react/24/outline'

const UserNavigation = () => {
  const location = useLocation()

  const navigation = [
    { name: 'Co-Pilots', href: '/home', icon: ChatBubbleLeftIcon },
    { name: 'Workflows', href: '/workflows', icon: Bars3Icon },
  ]
  return (
    <ul role="list" className="-mx-2 space-y-1">
      {navigation.map((item) => (
        <li key={item.name}>
          <Link
            to={item.href}
            className={clsx(
              item.href === location.pathname
                ? 'bg-gray-800 text-white'
                : 'text-gray-400 hover:text-white hover:bg-gray-800',
              'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
            )}
          >
            <item.icon className="h-6 w-6 shrink-0" aria-hidden="true" />
            {item.name}
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default UserNavigation
